import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    moduleId: module.id,
    templateUrl: './end-tkufat-rishum.component.html',

})

export class EndTkufatRishumComponent{
    constructor(private router: Router) { }
    back(event) {
        event.preventDefault();
        this.router.navigateByUrl('/peiluyots');
    }

}